export function calcTotalPhotoSize(sizes: { size2: number | string }[]): string {
  const total = sizes.reduce((sum, s) => sum + Number(s.size2 || 0), 0);
  return formatFileSize(total);
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);

  return `${size.toFixed(2)} ${units[i]}`;
}
